export default __webpack_public_path__ + "static/media/learose2-2048w.bd9d5b75.webp";